/** Application enum only; values stored as int on OfficialLicenseGrade.GardaVettingDurationValidityId. */
export enum GardaVettingDurationValidityEnum {
    FiscalYear = 1,
    CalendarYear = 2,
}
